import type { TicketAudit } from '../../api/types';

type Props = { audits: TicketAudit[] };

function auditIcon(action: string): string {
  if (action.includes('SLA_BREACH')) return '⚠';
  if (action.includes('ESCALATED')) return '↑';
  if (action.includes('CLOSE') || action.includes('COMPLETED')) return '✓';
  if (action.includes('COMMENT')) return '💬';
  if (action.includes('ASSIGNED')) return '👤';
  return '•';
}

function auditTone(action: string): string {
  if (action.includes('SLA_BREACH')) return 'audit-red';
  if (action.includes('ESCALATED_CROSS')) return 'audit-blue';
  if (action.includes('CLOSE') || action.includes('COMPLETED')) return 'audit-green';
  if (action.includes('COMMENT') || action.includes('EDIT') || action.includes('UPDATED')) {
    return 'audit-gray';
  }
  return 'audit-gray';
}

export default function AuditTab({ audits }: Props) {
  const sorted = [...audits].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
  );

  if (sorted.length === 0) {
    return <div className="empty-state">No audit entries.</div>;
  }

  return (
    <ul className="audit-timeline">
      {sorted.map((entry) => (
        <li key={entry.id} className={`audit-entry ${auditTone(entry.action)}`}>
          <span className="audit-icon" aria-hidden>
            {auditIcon(entry.action)}
          </span>
          <div className="audit-body">
            <p className="audit-desc">{entry.description}</p>
            {(entry.action.includes('ASSIGNED') || entry.action.includes('ESCALATED')) &&
              entry.ownership && (
                <p className="audit-context">
                  {entry.ownership.department.name}
                  {entry.ownership.team ? ` · ${entry.ownership.team.name}` : ''}
                </p>
              )}
            <p className="audit-meta">
              {entry.user.firstName} {entry.user.lastName} ·{' '}
              {new Date(entry.createdAt).toLocaleString()}
            </p>
          </div>
        </li>
      ))}
    </ul>
  );
}
